















import OtDocumentLayout from '@/components/documents/document-layout/ot-document-layout.vue';
import { Component, Vue } from 'vue-property-decorator';
import { ROUTE_PROJECT_DOCUMENT, ROUTE_PROJECT_DOCUMENT_ASSOCIATIONS } from '@/areas/projects/projects-routes';

@Component({
  components: {
    OtDocumentLayout,
  },
})
export default class OtProjectDocumentLayout extends Vue {
  private get detailsRouteName() {
    return ROUTE_PROJECT_DOCUMENT;
  }
  private get associationsRouteName() {
    return ROUTE_PROJECT_DOCUMENT_ASSOCIATIONS;
  }
}
